import script from "./email-form-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./email-form-modal.vue?vue&type=script&setup=true&lang=ts"

import "./email-form-modal.vue?vue&type=style&index=0&id=250b37d1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250b37d1"]])

export default __exports__